import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import ContactsAndConversationAPI from '../../api/contactsAndConversation';

export const state = {
  reports: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isDownloading: false,
  },
};

export const getters = {
  getAll: state => state.reports,
  getUIFlags: state => state.uiFlags,
};

export const actions = {
  async get({ commit }, params) {
    commit('setFetching', true);
    try {
      const response = await ContactsAndConversationAPI.getContactsAndConversations(params);
      commit('setReports', response.data);
    } catch (error) {
      // Handle error
    } finally {
      commit('setFetching', false);
    }
  },
  async download({ commit }, params) {
    commit('setDownloading', true);
    try {
      const response = await ContactsAndConversationAPI.download(params);
      commit('setDownloading', false);
    } catch (error) {
      // Handle error
    } finally {
      commit('setDownloading', false);
    }
  },
};

export const mutations = {
  setReports(state, reports) {
    state.reports = reports;
  },
  setFetching(state, isFetching) {
    state.uiFlags.isFetching = isFetching;
  },
  setDownloading(state, isDownloading) {
    state.uiFlags.isDownloading = isDownloading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
